import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkbox-observer"
export default class extends Controller {
  async connect() {
    this.element
      .querySelector("input[type='checkbox']")
      .addEventListener("change", (e) => {
        if (e.target.checked) {
          this.element.classList.add("checked");
        } else {
          this.element.classList.remove("checked");
        }
      });
  }
}
